import React, { useState } from "react";
import { Header } from "../Header";
import { Layout } from "./Layout";
import { Link } from "react-router-dom";
import { Sidebar } from "../Sidebar";

export const Result = () => {
  const [isSidebar, setSidebar] = useState(false);
  return (
    <>
      {isSidebar && <Sidebar />}
      <Header isSidebar={isSidebar} setSidebar={setSidebar} />
      <div
        _ngcontent-hdd-c80=""
        className=""
      >
        <div className="marquee">
          <marquee>
            Betfair exchange odds are under maintenance Bookmaker and Fancy odds
            are available to play.
          </marquee>
        </div>
        <app-reports _nghost-hdd-c162="" className="ng-star-inserted">
          <div _ngcontent-hdd-c162="" className="pcoded-main-container">
            <div
              _ngcontent-hdd-c162=""
              className="container-fluid pl-3 accounts-box"
            >
              <div _ngcontent-hdd-c162="" className="row account-tabs">
                <Layout />
                <div
                  _ngcontent-oqs-c169=""
                  className="col-12 mt-2 px-1 centralized_css"
                >
                  <app-results _nghost-dml-c163="" className="ng-star-inserted">
                    <div _ngcontent-dml-c163="" className="right-tab-box">
                      <div
                        _ngcontent-dml-c163=""
                        id="v-pills-tabContent"
                        className="tab-content"
                      >
                        <div
                          _ngcontent-dml-c163=""
                          id="v-pills-results"
                          role="tabpanel"
                          aria-labelledby="v-pills-results-tab"
                          className="tab-pane show active acc-stat-box"
                        >
                          <app-reports-input
                            _ngcontent-dml-c163=""
                            _nghost-dml-c153=""
                          >
                            <form
                              _ngcontent-dml-c153=""
                              noValidate=""
                              className="ng-untouched ng-pristine ng-valid"
                            >
                              <div _ngcontent-dml-c153="" className="row">
                                <div
                                  _ngcontent-dml-c153=""
                                  className="input-box grow col-md-5 ng-star-inserted"
                                >
                                  <label
                                    _ngcontent-dml-c153=""
                                    className="date-label"
                                  >
                                    Filter Type
                                  </label>
                                  <div
                                    _ngcontent-dml-c153=""
                                    className="input-group"
                                  >
                                    <select
                                      _ngcontent-dml-c153=""
                                      formcontrolname="filterType"
                                      className="custom-select custom-select-dropdown text-uppercase ng-untouched ng-pristine ng-valid"
                                      style={{ backgroundRepeat: "no-repeat" }}
                                    >
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="0: Object"
                                        className="ng-star-inserted"
                                      >
                                        Fancy{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="1: Object"
                                        className="ng-star-inserted"
                                      >
                                        Soccer{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="2: Object"
                                        className="ng-star-inserted"
                                      >
                                        Tennis{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="3: Object"
                                        className="ng-star-inserted"
                                      >
                                        Golf{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="4: Object"
                                        className="ng-star-inserted"
                                      >
                                        Cricket{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="5: Object"
                                        className="ng-star-inserted"
                                      >
                                        Rugby Union{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="6: Object"
                                        className="ng-star-inserted"
                                      >
                                        Boxing{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="7: Object"
                                        className="ng-star-inserted"
                                      >
                                        Horse Racing{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="8: Object"
                                        className="ng-star-inserted"
                                      >
                                        Motor Sport{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="9: Object"
                                        className="ng-star-inserted"
                                      >
                                        Special Bets{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="10: Object"
                                        className="ng-star-inserted"
                                      >
                                        Cycling{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="11: Object"
                                        className="ng-star-inserted"
                                      >
                                        Rowing{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="12: Object"
                                        className="ng-star-inserted"
                                      >
                                        Rugby League{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="13: Object"
                                        className="ng-star-inserted"
                                      >
                                        Darts{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="14: Object"
                                        className="ng-star-inserted"
                                      >
                                        Athletics{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="15: Object"
                                        className="ng-star-inserted"
                                      >
                                        Greyhound Racing{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="16: Object"
                                        className="ng-star-inserted"
                                      >
                                        Financial Bets{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="17: Object"
                                        className="ng-star-inserted"
                                      >
                                        Snooker{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="18: Object"
                                        className="ng-star-inserted"
                                      >
                                        American Football{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="19: Object"
                                        className="ng-star-inserted"
                                      >
                                        Baseball{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="20: Object"
                                        className="ng-star-inserted"
                                      >
                                        Basketball{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="21: Object"
                                        className="ng-star-inserted"
                                      >
                                        Hockey{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="22: Object"
                                        className="ng-star-inserted"
                                      >
                                        Ice Hockey{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="23: Object"
                                        className="ng-star-inserted"
                                      >
                                        Sumo Wrestling{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="24: Object"
                                        className="ng-star-inserted"
                                      >
                                        Ezugi Casino{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="25: Object"
                                        className="ng-star-inserted"
                                      >
                                        SuperSpade Casino{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="26: Object"
                                        className="ng-star-inserted"
                                      >
                                        Australian Rules{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="27: Object"
                                        className="ng-star-inserted"
                                      >
                                        Hurling{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="28: Object"
                                        className="ng-star-inserted"
                                      >
                                        Pool{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="29: Object"
                                        className="ng-star-inserted"
                                      >
                                        Chess{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="30: Object"
                                        className="ng-star-inserted"
                                      >
                                        Trotting{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="31: Object"
                                        className="ng-star-inserted"
                                      >
                                        Commonwealth Games{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="32: Object"
                                        className="ng-star-inserted"
                                      >
                                        Poker{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="33: Object"
                                        className="ng-star-inserted"
                                      >
                                        Winter Sports{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="34: Object"
                                        className="ng-star-inserted"
                                      >
                                        Handball{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="35: Object"
                                        className="ng-star-inserted"
                                      >
                                        Netball{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="36: Object"
                                        className="ng-star-inserted"
                                      >
                                        Swimming{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="37: Object"
                                        className="ng-star-inserted"
                                      >
                                        Badminton{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="38: Object"
                                        className="ng-star-inserted"
                                      >
                                        Gaelic Football{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="39: Object"
                                        className="ng-star-inserted"
                                      >
                                        International Rules{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="40: Object"
                                        className="ng-star-inserted"
                                      >
                                        Bridge{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="41: Object"
                                        className="ng-star-inserted"
                                      >
                                        Yachting{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="42: Object"
                                        className="ng-star-inserted"
                                      >
                                        Volleyball{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="43: Object"
                                        className="ng-star-inserted"
                                      >
                                        Bowls{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="44: Object"
                                        className="ng-star-inserted"
                                      >
                                        Floorball{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="45: Object"
                                        className="ng-star-inserted"
                                      >
                                        Exchange Poker{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="46: Object"
                                        className="ng-star-inserted"
                                      >
                                        Backgammon{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="47: Object"
                                        className="ng-star-inserted"
                                      >
                                        GAA Sports{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="48: Object"
                                        className="ng-star-inserted"
                                      >
                                        Gaelic Games{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="49: Object"
                                        className="ng-star-inserted"
                                      >
                                        International Markets{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="50: Object"
                                        className="ng-star-inserted"
                                      >
                                        Politics{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="51: Object"
                                        className="ng-star-inserted"
                                      >
                                        Mixed Martial Arts{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="52: Object"
                                        className="ng-star-inserted"
                                      >
                                        Current Affairs{" "}
                                      </option>
                                      <option
                                        _ngcontent-dml-c153=""
                                        value="53: Object"
                                        className="ng-star-inserted"
                                      >
                                        E-Sports{" "}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                                <div
                                  _ngcontent-dml-c153=""
                                  className="col-md-5"
                                >
                                  <label
                                    _ngcontent-dml-c153=""
                                    htmlFor="end-date-account-statement"
                                    className="date-label"
                                  >
                                    {" "}
                                    Date
                                  </label>
                                  <input
                                    _ngcontent-dml-c153=""
                                    type="datetime-local"
                                    formcontrolname="endDate"
                                    className="form-control date-input ng-untouched ng-pristine ng-valid"
                                  />
                                </div>
                                <div
                                  _ngcontent-dml-c153=""
                                  className="col-md-2 btn-box"
                                >
                                  <button
                                    _ngcontent-dml-c153=""
                                    type="submit"
                                    formnoValidate=""
                                  >
                                    {" "}
                                    Load Report{" "}
                                  </button>
                                </div>
                              </div>
                            </form>
                          </app-reports-input>
                          <div
                            _ngcontent-dml-c163=""
                            className="search-table results-table"
                          >
                            <div
                              _ngcontent-dml-c163=""
                              className="table-box no-more-tables"
                            >
                              <table
                                _ngcontent-dml-c163=""
                                className="table-borderless"
                              >
                                <thead _ngcontent-dml-c163="">
                                  <th
                                    _ngcontent-dml-c163=""
                                    className="text-left"
                                  >
                                    Competition Name
                                  </th>
                                  <th
                                    _ngcontent-dml-c163=""
                                    className="text-left"
                                  >
                                    Event Name
                                  </th>
                                  <th
                                    _ngcontent-dml-c163=""
                                    className="text-left"
                                  >
                                    Market Name
                                  </th>
                                  <th
                                    _ngcontent-dml-c163=""
                                    className="text-left"
                                  >
                                    Results
                                  </th>
                                </thead>
                                <tbody _ngcontent-dml-c163="">
                                  <tr
                                    _ngcontent-dml-c163=""
                                    className="ng-star-inserted"
                                  >
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Competition Name"
                                    >
                                      International Twenty20 Matches
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Event Name"
                                    >
                                      Australia v Pakistan
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Market Name"
                                    >
                                      10 OVER TOTAL ODD AUS
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Results"
                                    >
                                      Runner Not Found
                                    </td>
                                  </tr>
                                  <tr
                                    _ngcontent-dml-c163=""
                                    className="ng-star-inserted"
                                  >
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Competition Name"
                                    >
                                      International Twenty20 Matches
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Event Name"
                                    >
                                      Australia v Pakistan
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Market Name"
                                    >
                                      4th Wkt Lost To AUS Balls
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Results"
                                    >
                                      Runner Not Found
                                    </td>
                                  </tr>
                                  <tr
                                    _ngcontent-dml-c163=""
                                    className="ng-star-inserted"
                                  >
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Competition Name"
                                    >
                                      International Twenty20 Matches
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Event Name"
                                    >
                                      Australia v Pakistan
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Market Name"
                                    >
                                      4th Wkt Pship Boundaries AUS
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Results"
                                    >
                                      Runner Not Found
                                    </td>
                                  </tr>
                                  <tr
                                    _ngcontent-dml-c163=""
                                    className="ng-star-inserted"
                                  >
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Competition Name"
                                    >
                                      International Twenty20 Matches
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Event Name"
                                    >
                                      Australia v Pakistan
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Market Name"
                                    >
                                      H.M.B Face By M Stoinis
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Results"
                                    >
                                      Runner Not Found
                                    </td>
                                  </tr>
                                  <tr
                                    _ngcontent-dml-c163=""
                                    className="ng-star-inserted"
                                  >
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Competition Name"
                                    >
                                      International Twenty20 Matches
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Event Name"
                                    >
                                      Australia v Pakistan
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Market Name"
                                    >
                                      1st 4 Wkt AUS
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Results"
                                    >
                                      Runner Not Found
                                    </td>
                                  </tr>
                                  <tr
                                    _ngcontent-dml-c163=""
                                    className="ng-star-inserted"
                                  >
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Competition Name"
                                    >
                                      WBBL
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Event Name"
                                    >
                                      Adelaide Strikers WBBL v Hobart Hurricanes
                                      WBBL
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Market Name"
                                    >
                                      L Lee Run Bhav
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Results"
                                    >
                                      Runner Not Found
                                    </td>
                                  </tr>
                                  <tr
                                    _ngcontent-dml-c163=""
                                    className="ng-star-inserted"
                                  >
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Competition Name"
                                    >
                                      International Twenty20 Matches
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Event Name"
                                    >
                                      Australia v Pakistan
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Market Name"
                                    >
                                      5 Over PAK
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Results"
                                    >
                                      Runner Not Found
                                    </td>
                                  </tr>
                                  <tr
                                    _ngcontent-dml-c163=""
                                    className="ng-star-inserted"
                                  >
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Competition Name"
                                    >
                                      WBBL
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Event Name"
                                    >
                                      Adelaide Strikers WBBL v Hobart Hurricanes
                                      WBBL
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Market Name"
                                    >
                                      H.M.B Face By L Lee
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Results"
                                    >
                                      Runner Not Found
                                    </td>
                                  </tr>
                                  <tr
                                    _ngcontent-dml-c163=""
                                    className="ng-star-inserted"
                                  >
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Competition Name"
                                    >
                                      WBBL
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Event Name"
                                    >
                                      Adelaide Strikers WBBL v Hobart Hurricanes
                                      WBBL
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Market Name"
                                    >
                                      L Lee Boundaries
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Results"
                                    >
                                      Runner Not Found
                                    </td>
                                  </tr>
                                  <tr
                                    _ngcontent-dml-c163=""
                                    className="ng-star-inserted"
                                  >
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Competition Name"
                                    >
                                      International Twenty20 Matches
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Event Name"
                                    >
                                      Australia v Pakistan
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Market Name"
                                    >
                                      3rd WKT Lost To PAK Balls
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Results"
                                    >
                                      Runner Not Found
                                    </td>
                                  </tr>
                                  <tr
                                    _ngcontent-dml-c163=""
                                    className="ng-star-inserted"
                                  >
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Competition Name"
                                    >
                                      International Twenty20 Matches
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Event Name"
                                    >
                                      Australia v Pakistan
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Market Name"
                                    >
                                      H.M.B Face By M Rizwan
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Results"
                                    >
                                      Runner Not Found
                                    </td>
                                  </tr>
                                  <tr
                                    _ngcontent-dml-c163=""
                                    className="ng-star-inserted"
                                  >
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Competition Name"
                                    >
                                      International Twenty20 Matches
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Event Name"
                                    >
                                      Australia v Pakistan
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Market Name"
                                    >
                                      3rd WKT Pship Boundaries PAK
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Results"
                                    >
                                      Runner Not Found
                                    </td>
                                  </tr>
                                  <tr
                                    _ngcontent-dml-c163=""
                                    className="ng-star-inserted"
                                  >
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Competition Name"
                                    >
                                      WBBL
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Event Name"
                                    >
                                      Adelaide Strikers WBBL v Hobart Hurricanes
                                      WBBL
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Market Name"
                                    >
                                      11 Over HBHW
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Results"
                                    >
                                      Runner Not Found
                                    </td>
                                  </tr>
                                  <tr
                                    _ngcontent-dml-c163=""
                                    className="ng-star-inserted"
                                  >
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Competition Name"
                                    >
                                      International Twenty20 Matches
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Event Name"
                                    >
                                      Australia v Pakistan
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Market Name"
                                    >
                                      15 Over AUS
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Results"
                                    >
                                      Runner Not Found
                                    </td>
                                  </tr>
                                  <tr
                                    _ngcontent-dml-c163=""
                                    className="ng-star-inserted"
                                  >
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Competition Name"
                                    >
                                      International Twenty20 Matches
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Event Name"
                                    >
                                      Australia v Pakistan
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Market Name"
                                    >
                                      14 Over AUS
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Results"
                                    >
                                      Runner Not Found
                                    </td>
                                  </tr>
                                  <tr
                                    _ngcontent-dml-c163=""
                                    className="ng-star-inserted"
                                  >
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Competition Name"
                                    >
                                      International Twenty20 Matches
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Event Name"
                                    >
                                      Australia v Pakistan
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Market Name"
                                    >
                                      4 Over PAK
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Results"
                                    >
                                      Runner Not Found
                                    </td>
                                  </tr>
                                  <tr
                                    _ngcontent-dml-c163=""
                                    className="ng-star-inserted"
                                  >
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Competition Name"
                                    >
                                      International Twenty20 Matches
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Event Name"
                                    >
                                      Australia v Pakistan
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Market Name"
                                    >
                                      13 Over AUS
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Results"
                                    >
                                      Runner Not Found
                                    </td>
                                  </tr>
                                  <tr
                                    _ngcontent-dml-c163=""
                                    className="ng-star-inserted"
                                  >
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Competition Name"
                                    >
                                      International Twenty20 Matches
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Event Name"
                                    >
                                      Australia v Pakistan
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Market Name"
                                    >
                                      18 Over AUS
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Results"
                                    >
                                      Runner Not Found
                                    </td>
                                  </tr>
                                  <tr
                                    _ngcontent-dml-c163=""
                                    className="ng-star-inserted"
                                  >
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Competition Name"
                                    >
                                      International Twenty20 Matches
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Event Name"
                                    >
                                      Australia v Pakistan
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Market Name"
                                    >
                                      H.M.B Face By G Maxwell
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Results"
                                    >
                                      Runner Not Found
                                    </td>
                                  </tr>
                                  <tr
                                    _ngcontent-dml-c163=""
                                    className="ng-star-inserted"
                                  >
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Competition Name"
                                    >
                                      International Twenty20 Matches
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Event Name"
                                    >
                                      Australia v Pakistan
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Market Name"
                                    >
                                      5th Wkt Lost To AUS Balls
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                      data-title="Results"
                                    >
                                      Runner Not Found
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <pagination-controls
                                _ngcontent-dml-c163=""
                                id="results"
                                aria-label="Default pagination"
                                className="d-flex justify-content-center paginate ng-star-inserted"
                              >
                                <pagination-template>
                                  <ul
                                    className="ngx-pagination ng-star-inserted"
                                    aria-label="Pagination"
                                  >
                                    <li className="pagination-previous disabled ng-star-inserted">
                                      <span className="ng-star-inserted">
                                        {" "}
                                        Previous{" "}
                                        <span className="show-for-sr">
                                          page
                                        </span>
                                      </span>
                                    </li>
                                    <li className="small-screen"> 1 / 11 </li>
                                    <li className="current ng-star-inserted">
                                      <span className="show-for-sr ng-star-inserted">
                                        You're on page{" "}
                                      </span>
                                      <span className="ng-star-inserted">
                                        1
                                      </span>
                                    </li>
                                    <li className="ng-star-inserted">
                                      <Link
                                        tabIndex="0"
                                        className="ng-star-inserted"
                                      >
                                        <span className="show-for-sr">
                                          page{" "}
                                        </span>
                                        <span>2</span>
                                      </Link>
                                    </li>
                                    <li className="ng-star-inserted">
                                      <Link
                                        tabIndex="0"
                                        className="ng-star-inserted"
                                      >
                                        <span className="show-for-sr">
                                          page{" "}
                                        </span>
                                        <span>3</span>
                                      </Link>
                                    </li>
                                    <li className="ng-star-inserted">
                                      <Link
                                        tabIndex="0"
                                        className="ng-star-inserted"
                                      >
                                        <span className="show-for-sr">
                                          page{" "}
                                        </span>
                                        <span>4</span>
                                      </Link>
                                    </li>
                                    <li className="ng-star-inserted">
                                      <Link
                                        tabIndex="0"
                                        className="ng-star-inserted"
                                      >
                                        <span className="show-for-sr">
                                          page{" "}
                                        </span>
                                        <span>5</span>
                                      </Link>
                                    </li>
                                    <li className="ellipsis ng-star-inserted">
                                      <Link
                                        tabIndex="0"
                                        className="ng-star-inserted"
                                      >
                                        <span className="show-for-sr">
                                          page
                                        </span>
                                        <span>...</span>
                                      </Link>
                                    </li>
                                    <li className="ng-star-inserted">
                                      <Link
                                        tabIndex="0"
                                        className="ng-star-inserted"
                                      >
                                        <span className="show-for-sr">
                                          page{" "}
                                        </span>
                                        <span>11</span>
                                      </Link>
                                    </li>

                                    <li className="pagination-next ng-star-inserted">
                                      <Link
                                        tabIndex="0"
                                        aria-label="Next page"
                                        className="ng-star-inserted"
                                      >
                                        {" "}
                                        Next{" "}
                                        <span className="show-for-sr">
                                          page
                                        </span>
                                      </Link>
                                    </li>
                                  </ul>
                                </pagination-template>
                              </pagination-controls>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </app-results>
                </div>
              </div>
            </div>
          </div>
        </app-reports>
      </div>
    </>
  );
};
